// Vendors
import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
// Types
import { PermissionsContextType } from './types/permissions.context.type';
import { PermissionQueriedType } from 'types/permission-queried.type';

const PermissionsContext = createContext<PermissionsContextType>({} as PermissionsContextType);

const PermissionsContextProvider = ({ children }: PropsWithChildren): React.ReactElement => {
  const [permissions, setPermissions] = useState<PermissionQueriedType[]>([]); // Pasar a contexto.... sino se inicializa en cada import

  return (
    <PermissionsContext.Provider value={{ permissions, setPermissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};

const usePermissionsContextConsumerHook = (): PermissionsContextType =>
  useContext(PermissionsContext);

export { usePermissionsContextConsumerHook, PermissionsContextProvider };
